// extracted by mini-css-extract-plugin
module.exports = {"w8gqdxu":"w8gqdxu"};